export const iconFontAwesomeNatureWater = (
	<i className="fa-solid fa-water"></i>
);
